export default "__VITE_ASSET__CEPcre8a__"